import { useEffect, useMemo, useState } from 'react';
import { directoryOptions, organisationSettings, type Brand } from '../services/organisationSettings';

/** Brands from Admin → Organisations (cached). Empty until loaded or if they cannot be read. */
export function useBrands(): { brands: Brand[]; loading: boolean; reload: () => void } {
  const [brands, setBrands] = useState<Brand[]>([]);
  const [loading, setLoading] = useState(true);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    organisationSettings.list(version > 0)
      .then((rows) => { if (alive) setBrands(rows); })
      .catch(() => { if (alive) setBrands([]); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [version]);

  return { brands, loading, reload: () => setVersion((v) => v + 1) };
}

/**
 * Options for a customer's organisation (customers.organization_id / organization_name):
 * the brands offered for new work, plus the customer's current one so it still shows.
 */
export function useDirectoryOrganisationOptions(currentName?: string | null): Array<{ id: number; name: string }> {
  const { brands } = useBrands();
  return useMemo(() => directoryOptions(brands, currentName), [brands, currentName]);
}
